<template>
  <a-modal
    title="批量添加"
    :width="800"
    v-model="showDialog"
    :footer="null"
    @cancel="cancelEvent"
  >
    <a-upload-dragger
      :accept="accept"
      name="file"
      :multiple="true"
      :action="url"
      :before-upload="handleBefore"
      :headers="headers"
      :data="data"
      @change="handleChange"
    >
      <p class="ant-upload-drag-icon" style="margin-bottom:30px;">
        <a-icon type="inbox"/>
      </p>
      <p class="ant-upload-text">点击或将文件拖拽到这里上传</p>
      <p class="text-template"><span @click.stop="downloadFile">下载模板</span></p>
    </a-upload-dragger>
  </a-modal>
</template>

<script>
import formMixins from '../../../../../utils/mixins/formMixins'

export default {
  name: 'importFileDialog',
  mixins: [formMixins],
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true
    },
    url: {
      type: String,
      required: true,
      default: ''
    },
    templateUrl: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: undefined
    },
    accept: {
      type: String,
      default: '*'
    }
  },
  data() {
    return {
      showDialog: false,
      headers: {
        token: this.$store.getters.token
      },
      fileList: [],
      uploadUrl: this.getAppConfig().baseUrl + 'base/uploadFile/' + this.$store.getters.userInfo.merchantId
    }
  },
  watch: {
    'show': function(newVal, oldVal) {
      this.showDialog = newVal
    }
  },
  mounted() {
    this.showDialog = this.show
  },
  methods: {

    cancelEvent() {
      this.$emit('cancel', {})
    },
    handleBefore(file) {
      if (this.handleBeforeUploadExcelFile(file)) {
        return true
      }
      return false
    },
    // 下载模板
    downloadFile() {
      if (this.templateUrl) {
        window.open(this.templateUrl)
      }
    },
    handleChange(info) {
      if (info.file && info.file.status === 'done') {
        const response = info.file.response
        if (response.status === 1) {
          this.$message.success('批量导入成功')
          this.$emit('ok', {})
        } else {
          if (response.msg) {
            this.$message.error(response.msg)
          } else {
            this.$message.error('导入失败，请重试！')
          }
        }
      }
    }
  }
}
</script>
<style scoped>
.text-template {
  font-size: 16px;
  color: #FAAD14;
  font-weight: 400;
  text-align: right;
  padding-right: 20px;
}
</style>